import { render, staticRenderFns } from "./operationPromotionLayout.vue?vue&type=template&id=1ba95c0a&scoped=true&"
import script from "./operationPromotionLayout.vue?vue&type=script&lang=js&"
export * from "./operationPromotionLayout.vue?vue&type=script&lang=js&"
import style0 from "./operationPromotionLayout.vue?vue&type=style&index=0&id=1ba95c0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba95c0a",
  null
  
)

export default component.exports